import { useCallback, useEffect } from 'react';
import { BrandingColors } from 'types';

export const RESOLVE_COLORS: BrandingColors = {
  primaryColor: '#0000fe', // $color-primary
  secondaryColor: '#e7f1fc', // $color-secondary
};

export default function useBrandingColors(brandingColors: BrandingColors) {
  const { primaryColor, secondaryColor } = brandingColors || {};

  const applyStyles = useCallback(
    (property: string, value: string) =>
      document.body.style.setProperty(property, value),
    [],
  );

  const removeStyles = useCallback(
    (property: string) => document.body.style.removeProperty(property),
    [],
  );

  useEffect(() => {
    if (primaryColor) applyStyles('--color-primary', primaryColor);
    if (secondaryColor) applyStyles('--color-secondary', secondaryColor);

    return () => {
      if (primaryColor) removeStyles('--color-primary');
      if (secondaryColor) removeStyles('--color-secondary');
    };
  }, [applyStyles, primaryColor, removeStyles, secondaryColor]);
}
